import SpaceElement from './SpaceElement'

export default SpaceElement
